// extracted by mini-css-extract-plugin
export var label = "_g3-2";
export var slideContainer = "_g3-0";
export var slider = "_g3-1";